enum BrowserStatusEnum {
  OFFLINE = 'OFFLINE',
  OK = 'OK',
}

export default BrowserStatusEnum;
